// Mints a LiveKit access token via the backend `/api/voice/token` endpoint.
// Returns { token, url, roomName, identity } — the contract the
// `livekit-client` Room.connect() consumes.
//
// The backend names rooms `vella-call-{userId}-{epoch_ms}` so the LiveKit
// Cloud dispatch rule routes them to the "Vella" voice agent (Claude Opus
// + Deepgram STT + ElevenLabs TTS, deployed on Railway).

const BACKEND_ORIGIN =
  process.env.REACT_APP_API_URL ||
  "https://vella-backend-production.up.railway.app";

export async function fetchVoiceToken(surface = "voice_ttv") {
  const jwt = (() => {
    try { return localStorage.getItem("vella_token"); }
    catch { return null; }
  })();

  const headers = { "Content-Type": "application/json" };
  if (jwt) headers["Authorization"] = `Bearer ${jwt}`;

  const res = await fetch(`${BACKEND_ORIGIN}/api/voice/token`, {
    method: "POST",
    headers,
    body: JSON.stringify({ surface }),
  });

  if (!res.ok) {
    const text = await res.text().catch(() => "");
    console.warn(`[voiceToken] /api/voice/token ${res.status}: ${text || "request failed"}`);
    if (res.status === 401 || res.status === 403) {
      throw new Error("Voice mode needs you to sign in again. Refresh the page and try once more.");
    }
    if (res.status === 429) {
      throw new Error("Vella's voice service is busy. Try again in a few seconds.");
    }
    if (res.status >= 500) {
      throw new Error("Vella's voice service is temporarily unavailable. We're on it — try again in a minute.");
    }
    throw new Error("Couldn't start voice mode. Try again, and let us know if it keeps happening.");
  }

  return res.json();
}
